import React, { useEffect } from 'react'
import useGetApi from '../../services/useGetApi';
import QuizResultPopup from '../quizResult/QuizResultPopup'
import { Table } from 'antd';
import { useParams } from 'react-router-dom';

const AcademicProgres = () => {
  const { id } = useParams()
  const [
    isAcademicProgressLoading,
    academicProgressError,
    academicProgress,
    getAcademicProgres,
  ] = useGetApi(`progress/${id}`, [], true);

  useEffect(() => {
    getAcademicProgres(`progress/${id}`)
  }, [id])
  const columns = [
    {
      title: "Student",
      dataIndex: "student",
      key: "student",
      render: (text, record) => (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span>{record.userName}</span>
          <span>{record.userEmail}</span>
        </div>
      ),
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (text, record) => (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span>Enrolled from - {record.enrolledFromDate}</span>
          <span>Last seen on - {record.lastAccessedDate}</span>
          <span>Completed on - {record.completedOnDate}</span>
        </div>
      ),
    },
    {
      title: "Progress",
      dataIndex: "progress",
      key: "progress",
      render: (text, record) => (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span>Completed percentage - {record.completionPercentage}%</span>
          <span>Completed Lessons - {record.completedLessons}</span>
          <span>Watched duration- {record.watchedDuration}</span>
        </div>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => {
        return (
          <QuizResultPopup
            userId={record?.userId}
            courseId={record?.courseId}
          />
        );
      },
    }
  ];

  return (
    <div>
      <Table columns={columns} dataSource={academicProgress} />
    </div>
  )
}

export default AcademicProgres